import type { CSS } from '@grupoboticario/flora-react'

export const mainBoxStyle = { marginBottom: '$6' }
export const mainTextStyle = { marginBottom: '$4' }
export const mainGridStyle = {
  gridTemplateColumns: '1fr',
  gap: '$4',
  marginTop: '$4',
  '@desktop': { gridTemplateColumns: '1fr 2fr' }
}
export const limitGridStyle = {
  gridTemplateColumns: '1fr',
  gap: '$4',
  marginTop: '$4',
  '@desktop': { gridTemplateColumns: '2fr 2fr' }
}
export const pointsBoxStyle = { marginTop: '$2', width: '200px' }
export const descriptionRowCss: CSS = { background: '#F2f2f2' }
